import { Route, Redirect } from "react-router-dom";

function RutaProtegida({ component: Component, ...rest }) {
  const sesion = localStorage.getItem("session");
  return (
    <Route
      {...rest}
      render={(props) =>
        sesion ? <Component {...props} /> : <Redirect to="/Sesion" />
      }
    />
  );
}

export default RutaProtegida;